import { Skeleton } from "@/components/ui/skeleton";

export const NotificationSkeleton = () => (
  <Skeleton className="flex gap-3 p-4">
    <div className="flex grow gap-3">
      <Skeleton className="size-[40px] rounded-full bg-accent" />
      <div className="flex grow flex-col gap-2">
        <Skeleton className="h-4 w-1/3 bg-accent" />
        <Skeleton className="h-4 w-1/2 bg-accent" />
      </div>
    </div>
  </Skeleton>
);
